import React, { PropTypes } from 'react'
import classes from '../Settings.module.scss';
import {useTranslation} from 'react-i18next';

const Notification = (props) => {
  const {t} = useTranslation();
  return (
      <>
        <div onClick={props.onBack} className={[classes.title, classes.link].join(" ")}>
          <i className={["icon-Arrow---Up", classes.backButton, "backArrow"].join(" ")}></i>
          {t("Notifications")}
        </div>
      </>
  );
};

Notification.propTypes = {};
Notification.defaultProps = {};

export default Notification;